import { render, staticRenderFns } from "./QRPayment.vue?vue&type=template&id=968accb8&scoped=true"
import script from "./QRPayment.vue?vue&type=script&lang=js"
export * from "./QRPayment.vue?vue&type=script&lang=js"
import style0 from "./QRPayment.vue?vue&type=style&index=0&id=968accb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968accb8",
  null
  
)

export default component.exports